import React, {  useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next"
import { setFilters, resetFilters} from 'reducers/filtersDriversSlice';
import { resetPagination } from 'reducers/paginationDriversSlice';
import { useNavigate } from 'react-router-dom';
import { NON_ERASABLE_DRIVER_ID, ENDPOINT, LIMIT_PAGE } from "constants/variables"; 
import Box from '@mui/material/Box'; 
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Checkbox from '@mui/material/Checkbox';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import TextField from '@mui/material/TextField';
import "css/generalSettings.css";
import "css/customDialog.css";
import { successErrorAction, warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import TableSortingDriver from 'pages/driver/driversFilterList/SortingTablesDriver';
import PropTypes from 'prop-types';

const initialFiltersDriver= {
  "idFrom":"",
  "idTo":"",
  "firstnameFrom":"",
  "firstnameTo":"",
  "lastname1From":"",
  "lastname1To":"",
  "lastname2From":"",
  "lastname2To":"",
  "enabled":true,
  "notenabled":true,
  "languageFromES":"",
  "languageToES":"",
  "languageFromEN":"",
  "languageToEN":"",
  "emailsFrom":"",
  "emailsTo":"",
  "phonesFrom":"",
  "phonesTo":"",
};

const initialStateDriver = [{
   
  "id" : "",
  "firstname" : "",
  "lastname1" : "",
  "lastname2" : "",
  "fullname" : "", 
  "createdate":"",
  "enabled" : true,
  "birthdate" : null,
  "comments" : "",
  "documnettype_id":0,
  "documnettype_name": "",
  "numberdocument" : "",
  "language_id":0,
  "language_code": "",
  "language_namees": "",
  "language_nameen": "", 
  "phones" : [
    {
      "id":"",
      "phone":"",
      "defaultphone":""
    }
  ],
  "emails" : [
    {
      "id":"",
      "email":"",
      "defaultemail":""
    }
  ]  
}];

            
const DriversFilter = ({showModalDriverSettings,setShowModalDriverSettings}) => {
  const {t,i18n} = useTranslation(['listDataEmployees']);
  const token = useSelector((state) => state.loginUser.token); 
  const roles = useSelector((state) => state.loginUser.roles);  
  const DELETE_CODE = useSelector((state) => state.formatDIUser.delete_code); 
  const DELETE_CODE_DIRVER = useSelector((state) => state.formatDIUser.delete_code_employee); 
  const filtersDriversDetails = useSelector((state) => state.filtersDrivers);
  const [dataDriver, setDataDriver] = useState(initialStateDriver);
  const [filtersDriver, setFiltersDriver]= useState(filtersDriversDetails);
  const [numTotRegFilter,setNumTotRegFilter]= useState(0);
  const [numTotRegDriver,setNumTotRegDriver]= useState(0);
  const [errorsfiltersDriver, setErrorsfiltersDriver] = useState({});
  const [inputTextDriver, setInputTextDriver] = useState("");
  const [openCreatedataDriver,setOpenCreatedataDriver]= useState(false);
  const [openDeleteRowDriver,setOpenDeleteRowDriver]= useState(false);
  const [openEditRowDriver,setOpenEditRowDriver]= useState(false);
  const [openEditFilterDriver,setOpenEditFilterDriver]= useState(false);
  const [rowEditDriver,setRowEditDriver]= useState(initialStateDriver[0]);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [isLoadingErrorDriver, setIsLoadingErrorDriver] = useState(false);
  const [idCodeDelete,setIdCodeDelete]=useState(DELETE_CODE);
  const dispatch = useDispatch();
  const [activeOffsetDriver, setActiveOffsetDriver]= useState(false);
  const [currencyOffsetDriver, setCurrencyOffsetDriver] = useState(0);
  const [rangeOffsetDriver, setRangeOffsetDriver] = useState([{}]); 
  const [openVideoHelpStore, setOpenVideoHelpStore] = useState(false);
  const STORE_VIDEO_URL = "https://dn3b0526k2h3y.cloudfront.net/EMPLEADOS.mp4";
  const navigate = useNavigate(); 
 
  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showModalDriverSettings) {
        setDataDriver(initialStateDriver); 
        setNumTotRegFilter(0);
        setNumTotRegDriver(0);
        setErrorsfiltersDriver({});
        setInputTextDriver("");
        setOpenCreatedataDriver(false);
        setOpenDeleteRowDriver(false);
        setOpenEditRowDriver(false);
        setOpenEditFilterDriver(false);
        setRowEditDriver(initialStateDriver[0]); 
        setIsLoadingErrorDriver(false);
        setIdCodeDelete(DELETE_CODE);
        setActiveOffsetDriver(false);
        setCurrencyOffsetDriver(0);
        setRangeOffsetDriver([{}]); 
        setShowModalDriverSettings(false);
        setOpenVideoHelpStore(false);  
        dispatch(setLoading(false));
        dispatch(resetPagination());
        dispatch(resetFilters());
        setFiltersDriver(initialFiltersDriver);
        navigate("/home");
        return () => {};
      }
    },
    [
      setDataDriver,
      setFiltersDriver,
      setNumTotRegFilter,
      setNumTotRegDriver,
      setErrorsfiltersDriver,
      setInputTextDriver,
      setOpenCreatedataDriver,
      setOpenDeleteRowDriver,
      setOpenEditRowDriver,
      setOpenEditFilterDriver,
      setRowEditDriver, 
      setIsLoadingErrorDriver,
      setIdCodeDelete,
      setOpenVideoHelpStore,
      setActiveOffsetDriver,
      setCurrencyOffsetDriver,
      setRangeOffsetDriver,
      showModalDriverSettings,
      setShowModalDriverSettings, 
      DELETE_CODE,
      dispatch,
      navigate]
  );

  const closeModalDrivers = () => {    
    setDataDriver(initialStateDriver); 
    setNumTotRegFilter(0);
    setNumTotRegDriver(0);
    setErrorsfiltersDriver({});
    setInputTextDriver("");
    setOpenCreatedataDriver(false);
    setOpenDeleteRowDriver(false);
    setOpenEditRowDriver(false);
    setOpenEditFilterDriver(false);
    setRowEditDriver(initialStateDriver[0]); 
    setIsLoadingErrorDriver(false);
      setOpenVideoHelpStore(false);
    setIdCodeDelete(DELETE_CODE);
    setActiveOffsetDriver(false);
    setCurrencyOffsetDriver(0);
    setRangeOffsetDriver([{}]); 
    setShowModalDriverSettings(false); 
    dispatch(setLoading(false));
    dispatch(resetPagination());
    dispatch(resetFilters());
    setFiltersDriver(initialFiltersDriver); 
    navigate("/home");
    return () => {};
  };

  const openCreateOrEditdataDriver = () => {
    setInputTextDriver("");
    setOpenCreatedataDriver(true);
    navigate("/driverdetail/0");
  };

  const openEditfiltersDriver = () => { 
      setOpenEditFilterDriver(!openEditFilterDriver);
  };

  const handleSubmitFilterEditDriver = () => {
    setErrorsfiltersDriver(validateFormFilterDriver());
    if (Object.keys(errorsfiltersDriver).length === 0) {
      setErrorsfiltersDriver({});   
      dispatch(resetPagination());
      dispatch(setFilters(filtersDriver));  
      setOpenEditFilterDriver(false);
    }  else{
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  }

  const handleDeletefiltersDriver = () => {
    setErrorsfiltersDriver({});
    dispatch(resetFilters());
    dispatch(resetPagination());
    setFiltersDriver(initialFiltersDriver);
    setOpenEditFilterDriver(!openEditFilterDriver);
  };

  const handleCancelfiltersDriver = () => {
    setErrorsfiltersDriver({}); 
    setOpenEditFilterDriver(!openEditFilterDriver);
  };   

  const handleChangeEnabledFilter = (e) => {
    setFiltersDriver(filtersDriver => ({
      ...filtersDriver,
      enabled: !filtersDriver.enabled
    }));
  };
 
  const handleChangeNotEnabledFilter = (e) => {
    setFiltersDriver(filtersDriver => ({
      ...filtersDriver,
      notenabled: !filtersDriver.notenabled
    }));
  };

  const handleChangeFilterEditDriver = (e) => {
    const { name, value } = e.target;
    setFiltersDriver(filtersDriver => ({
      ...filtersDriver,
      [name]: value
    }));
  };

  const handleBlurFilterEditDriver = (e) => {
    setErrorsfiltersDriver(validateFormFilterDriver());
    handleChangeFilterEditDriver(e);
  };

  const toggleDrawerFilterEditDriver = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      handleCloseDataEditDriver();
    }
  };

  const validateFormFilterDriver = () => {

    let errorsfiltersDriver = {};
    let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;

    if (filtersDriver.idFrom!=="" & !regexNumber.test(filtersDriver.idFrom)) {
      errorsfiltersDriver.idFrom = 'Text_TextNoNumber';
    }
    if (filtersDriver.idTo!=="" & !regexNumber.test(filtersDriver.idTo)) {
      errorsfiltersDriver.idTo = 'Text_TextNoNumber';
    }
    if (filtersDriver.idFrom!=="" & !errorsfiltersDriver.idFrom!==undefined){
      if (filtersDriver.idTo!=="" & !errorsfiltersDriver.idTo!==undefined){
        if (parseInt(filtersDriver.idTo)<parseInt(filtersDriver.idFrom)){
          errorsfiltersDriver.idTo = 'Text_TextGreater_Id';
        }
      }
    }

    if (regexInvalidCharacters.test(filtersDriver.firstnameFrom)) {
      errorsfiltersDriver.firstnameFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersDriver.firstnameTo)) {
      errorsfiltersDriver.firstnameTo = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersDriver.lastname1From)) {
      errorsfiltersDriver.lastname1From = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersDriver.lastname1To)) {
      errorsfiltersDriver.lastname1To = 'Text_TextNoValid';
    } 

    if (regexInvalidCharacters.test(filtersDriver.lastname2From)) {
      errorsfiltersDriver.lastname2From = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersDriver.lastname2To)) {
      errorsfiltersDriver.lastname2To = 'Text_TextNoValid';
    } 
  
    if (regexInvalidCharacters.test(filtersDriver.emailsFrom)) {
      errorsfiltersDriver.emailsFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersDriver.emailsTo)) {
      errorsfiltersDriver.emailsTo = 'Text_TextNoValid';
    } 
  
    if (regexInvalidCharacters.test(filtersDriver.phonesFrom)) {
      errorsfiltersDriver.phonesFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersDriver.phonesTo)) {
      errorsfiltersDriver.phonesTo = 'Text_TextNoValid';
    } 
  
    if (filtersDriver.firstnameTo!=="" & filtersDriver.firstnameTo<filtersDriver.firstnameFrom){
      errorsfiltersDriver.firstnameTo = 'Text_TextGreater_firstname';
    }

    if (filtersDriver.lastname1To!=="" & filtersDriver.lastname1To<filtersDriver.lastname1From){
      errorsfiltersDriver.lastname1To = 'Text_TextGreater_lastname1';
    }

    if (filtersDriver.lastname2To!=="" & filtersDriver.lastname2To<filtersDriver.lastname2From){
      errorsfiltersDriver.lastname2To = 'Text_TextGreater_lastname2';
    }

    if (filtersDriver.emailsTo!=="" & filtersDriver.emailsTo<filtersDriver.emailsFrom){
      errorsfiltersDriver.emailsTo = 'Text_TextGreater_emails';
    }

    if (filtersDriver.phonesTo!=="" & filtersDriver.phonesTo<filtersDriver.phonesFrom){
      errorsfiltersDriver.phonesTo = 'Text_TextGreater_phones';
    }
 
    return errorsfiltersDriver;
  }  

  const filtereddataDriver = dataDriver.filter((el) => {
    if (inputTextDriver === '') {
        return el;
    }
    else {
      let dataTranslate = 
        String(el.id || '') +
        String(el.firstname || '') +
        String(el.lastname1 || '') +
        String(el.lastname2 || '') +
        String(el.fullname || '') +
        String(el.numberdocument || '')
        +(el.emails!==undefined && el.emails!==null && el.emails.length>0?el.emails.map(current => {return (current.email )}):"")
        +(el.phones!==undefined && el.phones!==null && el.phones.length>0?el.phones.map(current => {return (current.phone )}):"");
      let result = dataTranslate.toLowerCase().includes(inputTextDriver.toLowerCase());
      return result; 
    }
  })

  let inputHandlerDriver = (e) => {
      var lowerCase = e.target.value.toLowerCase();
      setInputTextDriver(lowerCase);
  };

  const handleChangeDeleteRowDriver = (e) => {
    const value  = e.target.value;
    setIdCodeDelete(value);
  };

  const handleCancelDeleteRowDriver = () => {
    setRowEditDriver(initialStateDriver[0]);
    dispatch(setLoading(false));
    setIsLoadingErrorDriver(false);
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRowDriver(false);
  };
 
  const handleCloseDeleteRowDriver = (e) => {
    if (idCodeDelete !== DELETE_CODE_DIRVER) {
      dispatch(warningErrorAction(t('Text_InvalidCode')));
      return;
    }
    let isMounted = true;
    if (e.key !== 'Escape') {
      if (rowEditDriver.id !== '') {
        const fetchData = async () => {
          dispatch(setLoading(true));
          try {
            const getData = await helpHttp().del(ENDPOINT, `driver/deletedriver`, token, rowEditDriver);
            if (getData.status === "OK") {
              if (isMounted) {
                dispatch(successErrorAction(t('Text_ValidCode')));
                dispatch(successErrorAction(t('Text_DeleteField')));
              }
            } else {
              if (isMounted) {
                dispatch(warningErrorAction(t(getData.cause)));
              }
            }
            dispatch(setLoading(false));
          } catch (error) {
            dispatch(setLoading(false));
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
          }   
        };
        fetchData(); 
      } else {
        dispatch(warningErrorAction(t('Text_InvalidId')));
      }
    }
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRowDriver(false);
    setIsLoadingErrorDriver(false);
    handleCloseDataEditDriver();
    return () => { isMounted = false;};
  };
 

  const handleCloseDataEditDriver = () => {
    setOpenCreatedataDriver(false);
    setOpenEditRowDriver(false);
    setRowEditDriver(openEditRowDriver?rowEditDriver:initialStateDriver[0]);
    dispatch(setLoading(false));
    setIsLoadingErrorDriver(false);
    toggleDrawerFilterEditDriver(false);
	};

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);
 
  useEffect(() => {
    if (numTotRegDriver > LIMIT_PAGE) {
      setActiveOffsetDriver(true);
      const newRangeOffset = [
        {
          value: 0,
          label: " 1 - " + Number(LIMIT_PAGE).toLocaleString('de-DE'),
        }
      ];
      for (let i = Number(LIMIT_PAGE); i < numTotRegDriver; i += Number(LIMIT_PAGE)) {
        newRangeOffset.push({
          value: i,
          label: " " + (i + 1).toLocaleString('de-DE') + " - " + (i + Number(LIMIT_PAGE)).toLocaleString('de-DE'),
        });
      }
      setRangeOffsetDriver(newRangeOffset);
    } else {
      setCurrencyOffsetDriver(0);
      setActiveOffsetDriver(false);
      setRangeOffsetDriver([{}]);
    }
  }, [numTotRegDriver]);

  useEffect(() => {
    let isMounted = true;
    const fetchnumTotRegDriver = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, `driver/getinformationtabledriver`, token);
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            setDataDriver(initialStateDriver);
            dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
          }
        } else if (isMounted) {
          setNumTotRegDriver(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };

    const fetchnumTotRegFilter = async () => { 
      try {
        const getData = await helpHttp().post(ENDPOINT, `driver/getcountfilterdriver`, token, filtersDriversDetails);
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            setDataDriver(initialStateDriver);
            dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
          }
        } else if (isMounted) {
          setNumTotRegFilter(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
    const fetchdataDriver = async () => {
      dispatch(setLoading(true));
      try { 
        const getData = await helpHttp().get3(ENDPOINT, `driver/drivers`, token, currencyOffsetDriver, LIMIT_PAGE, filtersDriversDetails);
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            setDataDriver(initialStateDriver);
            dispatch(setLoading(false));
            dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
          }
        } else if (isMounted) {
          setDataDriver(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };

    if (showModalDriverSettings){
      fetchnumTotRegDriver();
      fetchnumTotRegFilter();
      fetchdataDriver(); 
      return () => { isMounted = false; };
    }
  }, [t,token,dispatch,i18n.language,openCreatedataDriver,openDeleteRowDriver,setOpenDeleteRowDriver,setOpenEditRowDriver,openEditRowDriver,rowEditDriver,showModalDriverSettings,currencyOffsetDriver,filtersDriversDetails]);

  return (
    <>
       {showModalDriverSettings ? ( 
       <div className="container-fluid formdi-pending-page">
          <div id="myDIV" className="formdi-pending-header">
            <h1 className="formdi-pending-title">
              {isLoadingErrorDriver?<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>:isLoadingData?<CircularProgress color={openDeleteRowDriver?"warning":"primary"}/>:<i className="fas fa-address-card text-warning"></i>} {t('Text_Driver_Table')}
            </h1>
            <div className="formdi-pending-header-actions"> 
              {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Drivers_Create'))? (
                <div>
                  <button type="button"  className="formdi-pending-btn formdi-pending-btn--primary"  onClick={openCreateOrEditdataDriver} >
                    {t('Button_Create')}
                  </button>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary"  onClick={closeModalDrivers} >
                    {t('Button_Back')}
                  </button>
                </div>
              ) : (
                <div>
                  <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary" onClick={closeModalDrivers} >
                    {t('Button_Back')}
                  </button>
                </div>
              )} 
              <div
                className="video-tutorial-cta"
                onClick={() => setOpenVideoHelpStore(true)}
                title={t('Text_Video_View')}
              >
                <div className="video-tutorial-cta__circle">
                  <i className="fas fa-play"></i>
                </div>

                <div className="video-tutorial-cta__pill">
                  <span className="video-tutorial-cta__tag">{t('Text_Video_Tutorial')}</span>
                  <span className="video-tutorial-cta__title">{t('Button_Video')}</span>
                </div>
              </div> 
            </div> 
          </div>  
          <br/> 
          {/* Buscador */}
           <div className="formdi-pending-search">
            <TextField
              id="outlined-basic"
              variant="outlined"
              inputProps={{ style: {fontSize: '18px'} }}
              InputLabelProps={{ style: {fontSize: '18px', background: '#f8f9fc'}}} 
              value={inputTextDriver}
              placeholder={t('Text_Driver_Search')} 
              onChange={inputHandlerDriver}
              fullWidth
              label={t('Text_Driver_Search')}>
            </TextField>
          </div> 
          <br/>
          <div id="myNewDIV" className="formdi-pending-filters">
            <h1 className="formdi-pending-filter-title">{t("Text_Filter")}</h1>
            <div className="formdi-pending-filters-row">
              <button type="button" className={`formdi-pending-chip ${filtersDriversDetails.idFrom !== "" || filtersDriversDetails.idTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditfiltersDriver} >
                <span className={`formdi-pending-dot ${ filtersDriversDetails.idFrom !== "" || filtersDriversDetails.idTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Code")}
              </button>
              <button type="button" className={`formdi-pending-chip ${filtersDriversDetails.firstnameFrom !== "" || filtersDriversDetails.firstnameTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditfiltersDriver} >
                <span className={`formdi-pending-dot ${ filtersDriversDetails.firstnameFrom !== "" || filtersDriversDetails.firstnameTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_firstname")}
              </button> 
              <button type="button" className={`formdi-pending-chip ${filtersDriversDetails.lastname1From !== "" || filtersDriversDetails.lastname1To !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditfiltersDriver} >
                <span className={`formdi-pending-dot ${ filtersDriversDetails.lastname1From !== "" || filtersDriversDetails.lastname1To !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_lastname1")}
              </button>  
              <button type="button" className={`formdi-pending-chip ${filtersDriversDetails.lastname2From !== "" || filtersDriversDetails.lastname2To !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditfiltersDriver} >
                <span className={`formdi-pending-dot ${ filtersDriversDetails.lastname2From !== "" || filtersDriversDetails.lastname2To !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_lastname2")}
              </button> 

               <button type="button" className={`formdi-pending-chip ${filtersDriversDetails.emailsFrom !== "" || filtersDriversDetails.emailsTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditfiltersDriver} >
                <span className={`formdi-pending-dot ${ filtersDriversDetails.emailsFrom !== "" || filtersDriversDetails.emailsTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Email")}
              </button>  
              <button type="button" className={`formdi-pending-chip ${filtersDriversDetails.phonesFrom !== "" || filtersDriversDetails.phonesTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditfiltersDriver} >
                <span className={`formdi-pending-dot ${ filtersDriversDetails.phonesFrom !== "" || filtersDriversDetails.phonesTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Phone")}
              </button> 

              <button type="button" className={`formdi-pending-chip ${filtersDriversDetails.enabled ? "formdi-pending-chip--active": "" }`}  onClick={openEditfiltersDriver} >
                <span className={`formdi-pending-dot ${ filtersDriversDetails.enabled? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_Enabled")}
              </button> 
              <button type="button" className={`formdi-pending-chip ${filtersDriversDetails.notenabled ? "formdi-pending-chip--active": "" }`}  onClick={openEditfiltersDriver} >
                <span className={`formdi-pending-dot ${ filtersDriversDetails.notenabled? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_disabled")}
              </button>
            </div>
          </div>
          <br/> 
          {!isLoadingData ?
            <>
              <div className="formdi-pending-card-flat">
                <div className="formdi-pending-card-content">
                  <TableSortingDriver
                    dataDriver={filtereddataDriver}
                    numTotRegFilter={ numTotRegFilter}
                    titleTable={t('Text_Driver_Table')}
                    setOpenDeleteRowDriver={setOpenDeleteRowDriver}
                    setRowEditDriver={setRowEditDriver}
                    showEditButtonDriver={roles[0].listmenus.find((key)=>(key.name==='SubMenu_Drivers_Edit'))?true:false}
                    showDeleteButtonDriver={roles[0].listmenus.find((key)=>(key.name==='SubMenu_Drivers_Delete'))?true:false}
                    numTotRegDriver={numTotRegDriver}
                    activeOffsetDriver={activeOffsetDriver}
                    rangeOffsetDriver={rangeOffsetDriver}
                    currencyOffsetDriver={currencyOffsetDriver}
                    setCurrencyOffsetDriver={setCurrencyOffsetDriver} 
                    minvalue={Number(NON_ERASABLE_DRIVER_ID)}> 
                  </TableSortingDriver>
                </div>             
              </div>
              {openEditFilterDriver &&
               <div>
               <SwipeableDrawer
                 anchor='right'
                 open={true}
                 onClose={toggleDrawerFilterEditDriver(false)}
                 onOpen={toggleDrawerFilterEditDriver(true)}>
                 <Container >
                   <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '850' }}>
                     <br/>
                       <div id="myDIV">
                         <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                       </div>
                       <hr className="sidebar-divider d-none d-md-block"/>
                       <form className="createfiltedriver" onSubmit={handleCancelfiltersDriver}>  
                         <div className="form-floating mb-3 px-4 primary">
                           <div className="form-group">
                             <TextField
                              id="idFrom" 
                              name="idFrom" 
                              value={filtersDriver.idFrom}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={errorsfiltersDriver.idFrom!=null?t(errorsfiltersDriver.idFrom):t('Text_Filter_Code_From')}
                              placeholder={t('PlaceHolder_Filter_Code_From')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditDriver}
                              onChange={handleChangeFilterEditDriver}/>
                             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                             <TextField
                              id="idTo" 
                              name="idTo"
                              value={filtersDriver.idTo}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={errorsfiltersDriver.idTo!=null?t(errorsfiltersDriver.idTo):t('Text_Filter_Code_To')}
                              placeholder={t('PlaceHolder_Filter_Code_to')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditDriver}
                              onChange={handleChangeFilterEditDriver}/>
                           </div>
                           <div className="form-group">
                             <TextField
                              id="firstnameFrom" 
                              name="firstnameFrom"
                              value={filtersDriver.firstnameFrom}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={errorsfiltersDriver.firstnameFrom!=null?t(errorsfiltersDriver.firstnameFrom):t('Text_Filter_firstname_From')}
                              placeholder={t('PlaceHolder_Filter_firstname_From')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditDriver}
                              onChange={handleChangeFilterEditDriver}/>
                             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                             <TextField
                              id="firstnameTo" 
                              name="firstnameTo"
                              value={filtersDriver.firstnameTo}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={errorsfiltersDriver.firstnameTo!=null?t(errorsfiltersDriver.firstnameTo):t('Text_Filter_firstname_To')}
                              placeholder={t('PlaceHolder_Filter_firstname_to')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditDriver}
                              onChange={handleChangeFilterEditDriver}/>
                           </div>
                           <div className="form-group">
                             <TextField
                              id="lastname1From" 
                              name="lastname1From"
                              value={filtersDriver.lastname1From}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={errorsfiltersDriver.lastname1From!=null?t(errorsfiltersDriver.lastname1From):t('Text_Filter_lastname1_From')}
                              placeholder={t('PlaceHolder_Filter_lastname1_From')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditDriver}
                              onChange={handleChangeFilterEditDriver}/>
                             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                             <TextField
                              id="lastname1To" 
                              name="lastname1To"
                              value={filtersDriver.lastname1To}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={errorsfiltersDriver.lastname1To!=null?t(errorsfiltersDriver.lastname1To):t('Text_Filter_lastname1_To')}
                              placeholder={t('PlaceHolder_Filter_lastname1_to')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditDriver}
                              onChange={handleChangeFilterEditDriver}/>
                           </div>
                           <div className="form-group">
                             <TextField
                              id="lastname2From" 
                              name="lastname2From"
                              value={filtersDriver.lastname2From}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={errorsfiltersDriver.lastname2From!=null?t(errorsfiltersDriver.lastname2From):t('Text_Filter_lastname2_From')}
                              placeholder={t('PlaceHolder_Filter_lastname2_From')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditDriver}
                              onChange={handleChangeFilterEditDriver}/>
                             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                             <TextField
                              id="lastname2To" 
                              name="lastname2To"
                              value={filtersDriver.lastname2To}
                              inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              label={errorsfiltersDriver.lastname2To!=null?t(errorsfiltersDriver.lastname2To):t('Text_Filter_lastname2_To')}
                              placeholder={t('PlaceHolder_Filter_lastname2_to')}
                              variant="outlined"
                              onBlur={handleBlurFilterEditDriver}
                              onChange={handleChangeFilterEditDriver}/>
                            </div>
                            <div className="form-group">
                              <TextField
                                id="emailsFrom" 
                                name="emailsFrom"
                                value={filtersDriver.emailsFrom}
                                inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                label={errorsfiltersDriver.emailsFrom!=null?t(errorsfiltersDriver.emailsFrom):t('Text_Filter_emails_From')}
                                placeholder={t('PlaceHolder_Filter_emails_From')}
                                variant="outlined"
                                onBlur={handleBlurFilterEditDriver}
                                onChange={handleChangeFilterEditDriver}/>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <TextField
                                id="emailsTo" 
                                name="emailsTo"
                                value={filtersDriver.emailsTo}
                                inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                label={errorsfiltersDriver.emailsTo!=null?t(errorsfiltersDriver.emailsTo):t('Text_Filter_emails_To')}
                                placeholder={t('PlaceHolder_Filter_emails_to')}
                                variant="outlined"
                                onBlur={handleBlurFilterEditDriver}
                                onChange={handleChangeFilterEditDriver}/>
                            </div>
                            <div className="form-group">
                                <TextField
                                id="phonesFrom" 
                                name="phonesFrom"
                                value={filtersDriver.phonesFrom}
                                inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 30 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                label={errorsfiltersDriver.phonesFrom!=null?t(errorsfiltersDriver.phonesFrom):t('Text_Filter_phones_From')}
                                placeholder={t('PlaceHolder_Filter_phones_From')}
                                variant="outlined"
                                onBlur={handleBlurFilterEditDriver}
                                onChange={handleChangeFilterEditDriver}/>
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <TextField
                                id="phonesTo" 
                                name="phonesTo"
                                value={filtersDriver.phonesTo}
                                inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 30 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                label={errorsfiltersDriver.phonesTo!=null?t(errorsfiltersDriver.phonesTo):t('Text_Filter_phones_To')}
                                placeholder={t('PlaceHolder_Filter_phones_to')}
                                variant="outlined"
                                onBlur={handleBlurFilterEditDriver}
                                onChange={handleChangeFilterEditDriver}/>
                                </div>
                            {i18n.language==="en"?
                             <>
                               <div className="form-group">
                                 <Checkbox
                                    id="enabled" 
                                    name="enabled"
                                    checked={filtersDriver.enabled}
                                    onChange={handleChangeEnabledFilter}
                                    variant="standard"
                                    sx={{
                                      '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                    }}
                                  />
                                 &nbsp;&nbsp;    
                                 <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_Driver_Habilty')}</label>  
                                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                 <Checkbox
                                   id="notenabled" 
                                   name="notenabled"
                                   checked={filtersDriver.notenabled}
                                   onChange={handleChangeNotEnabledFilter}
                                   variant="standard"
                                    sx={{
                                      '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                    }}
                                  />
                                 &nbsp;&nbsp;    
                                 <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_Driver_Not_Habilty')}</label>    
                               </div>
                             </>  
                           :
                             <>
                               <div className="form-group">  
                               <Checkbox
                                 id="enabled" 
                                 name="enabled"
                                 checked={filtersDriver.enabled}
                                 onChange={handleChangeEnabledFilter}
                                 variant="standard"
                                  sx={{
                                    '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                  }}
                                />
                               &nbsp;&nbsp;    
                               <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_Driver_Habilty')}</label>  
                               &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                               <Checkbox
                                 id="notenabled" 
                                 name="notenabled"
                                 checked={filtersDriver.notenabled}
                                 onChange={handleChangeNotEnabledFilter}
                                 variant="standard"
                                  sx={{
                                    '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                  }}
                                />
                               &nbsp;&nbsp;    
                               <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_Driver_Not_Habilty')}</label>    
                             </div>
                           </>
                         }
                         </div>
                        <hr className="sidebar-divider d-none d-md-block" />
                        <div className="formdi-pending-action-group">
                          <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitFilterEditDriver}>
                            {t('Button_Apply')}
                          </button> 
                          <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeletefiltersDriver}>
                            {t('Button_Cancel_Filters')}
                          </button>
                        </div> 
                     </form>
                   </Box>
                 </Container>
               </SwipeableDrawer>
             </div>
            }  
            <Dialog
              open={openVideoHelpStore}
              onClose={() => setOpenVideoHelpStore(false)}
              maxWidth="md"
              fullWidth
              PaperProps={{
                style: {
                  borderRadius: "20px",
                  overflow: "hidden"
                }
              }}
            >
              <DialogTitle
                sx={{
                  color: "#4e73df",
                  fontWeight: 500,
                  fontSize: "1.4rem"
                }}
              >
                {t('Text_Video_Explain_Drivers').toUpperCase()}
              </DialogTitle> 
              <DialogContent sx={{ padding: 0, background: "#000" }}>
                <div className="store-video-wrapper">
                  <iframe
                    width="100%"
                    height="100%"
                    src={STORE_VIDEO_URL}
                    title={t('Text_Video_Explain')}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
              </DialogContent>

              <DialogActions sx={{ padding: "12px 20px" }}>
                <Button
                  onClick={() => setOpenVideoHelpStore(false)}
                  className="my-dialog-button-cancel"
                >
                  {t('Button_Close')}
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog open={openDeleteRowDriver} onClose={handleCancelDeleteRowDriver} PaperProps={{ className: "my-dialog-paper-danger" }} >
            <DialogTitle className="my-dialog-title-danger">
              {t('Text_Delete')} {rowEditDriver.id}  - {rowEditDriver.fullname} 
            </DialogTitle>
              <DialogContent>
                <DialogContentText className="my-dialog-contentText-danger">
                  {t("Text_Line1")}<br />
                  {t("Text_Line2")}
                </DialogContentText>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="idCode"
                    label={t("Text_Label")}
                    type="text"
                    fullWidth
                    variant="standard"
                    className="my-dialog-input-danger"
                    defaultValue={idCodeDelete}
                    onChange={handleChangeDeleteRowDriver}
                  />
                </DialogContent>
              <DialogActions className="my-dialog-actions">
              <Button
                onClick={handleCancelDeleteRowDriver}
                className="my-dialog-button-cancel-danger"
              >
                {t("Button_Cancel")}
              </Button>
              <Button
                variant="contained"
                onClick={handleCloseDeleteRowDriver}
                className="my-dialog-button-delete"
              >
                {t("Button_Delete")}
              </Button>
            </DialogActions>
            </Dialog>  
          {/* End Content Row */}
          </>:
            <LoadingNews/>
          }
        </div>
        //* End Page Content *//
      ) :  null }
    </>
  )
}

DriversFilter.propTypes = {
  showModalDriverSettings: PropTypes.bool.isRequired,
  setShowModalDriverSettings: PropTypes.func.isRequired 
};

export default DriversFilter;
